import React from 'react';
import Images from '../../../Utils/images';
import {
  formatStringToTitleCase,
  formatToTitleCase,
  getTimeWithTimeZoneAbbreviationNew,
} from '../../../Utils/helperFns';
import { useNavigate } from 'react-router-dom';
import ToolTipComponent from '../../../Components/ToolTipComponent';
import { ROUTES } from '../../../helpers/contants';
import { setRiskBreadCrumbs } from '../../../redux/commonSlice';
import dayjs from 'dayjs';

interface ThreatCardProps {
  className?: string;
  iconClassName?: string;
  data?: any;
  isStudio?: boolean;
  isProduction?: boolean;
  isEpisode?: boolean;
  productionType?: string;
  studioId?: string;
}

const ThreatCard: React.FC<ThreatCardProps> = ({
  className = '',
  iconClassName = 'urgent-icon',
  data,
  isStudio,
  isProduction,
  isEpisode,
  productionType,
  studioId,
}) => {
  const navigate = useNavigate();

  return (
    <div
      className={`threat-card${className ? ' ' + className : ''}`}
      onClick={() => {
        const production = isStudio
          ? [
              {
                name: 'production',
                type: 'production risk dashboard',
                title: data?.name,
                path: `${ROUTES.PRODUCTION_SECURITY_DASHBOARD}?productionId=${data?._id}&name=${data?.name}`,
              },
            ]
          : (isProduction && productionType === 'TV Series') ||
            productionType === 'Multiple Live Events'
          ? [
              {
                name: 'episode',
                type: 'episode risk dashboard',
                title: `${
                  data?.episodeNumber ? data?.episodeNumber + ' - ' : ''
                }${data?.name}`,
                path: `${ROUTES.EPIOSDE_SECURITY_DASHBOARD}?episodeId=${
                  data?._id
                }&name=${
                  data?.episodeNumber ? data?.episodeNumber + ' - ' : ''
                }${data?.name}`,
              },
            ]
          : isProduction
          ? [
              {
                name: 'set',
                type: 'set risk dashboard',
                title: data?.name?.toUpperCase(),
                path: `${ROUTES.SET_SECURITY_DASHBOARD}?setId=${
                  data?._id
                }&name=${data?.name?.toUpperCase()}`,
              },
            ]
          : isEpisode
          ? [
              {
                name: 'set',
                type: 'set risk dashboard',
                title: data?.name?.toUpperCase(),
                path: `${ROUTES.SET_SECURITY_DASHBOARD}?setId=${
                  data?._id
                }&name=${data?.name?.toUpperCase()}`,
              },
            ]
          : [
              {
                name: 'set',
                type: 'set risk dashboard',
                title: data?.name?.toUpperCase(),
                path: `${ROUTES.SET_SECURITY_DASHBOARD}?setId=${
                  data?._id
                }&name=${data?.name?.toUpperCase()}`,
              },
            ];
        setRiskBreadCrumbs(production);
        isStudio
          ? navigate(
              `/production-security-dashboard?productionId=${data?._id}&name=${data?.name}`,
            )
          : (isProduction && productionType === 'TV Series') ||
            productionType === 'Multiple Live Events'
          ? navigate(
              `/episode-security-dashboard?episodeId=${data?._id}&name=${data?.episodeNumber} - ${data?.name}`,
            )
          : isProduction
          ? navigate(
              `/set-security-dashboard?setId=${
                data?._id
              }&name=${data?.name?.toUpperCase()}`,
            )
          : isEpisode
          ? navigate(
              `/set-security-dashboard?setId=${
                data?._id
              }&name=${data?.name?.toUpperCase()}`,
            )
          : navigate(
              `/set-security-dashboard?setId=${
                data?._id
              }&name=${data?.name?.toUpperCase()}`,
            );
      }}
    >
      <img
        src={
          data?.image
            ? data?.image
            : data?.fallbackImage
            ? data?.fallbackImage
            : Images.VENDOR_PLACEHOLDER
        }
      />
      <div className="text">
        <div className="title">
          <h2
            className="MuiTypography-body2 fw600"
            title={
              data?.type === 'SET'
                ? data?.name?.toUpperCase()
                : data?.type === 'EPISODE'
                ? `${data?.episodeNumber ? data?.episodeNumber + ' - ' : ''}${
                    data?.name
                  }`
                : data?.name
            }
          >
            {data?.type === 'SET'
              ? data?.name?.toUpperCase()
              : data?.type === 'EPISODE'
              ? `${data?.episodeNumber ? data?.episodeNumber + ' - ' : ''}${
                  data?.name
                }`
              : data?.name}
          </h2>
          {isStudio ? (
            <span className="type white">{data?.type}</span>
          ) : (isProduction && productionType !== 'TV Series') ||
            productionType !== 'Multiple Live Events' ||
            isEpisode ? (
            <div className="d-flex align-center">
              <i className="location-icon"></i>{' '}
              <p className="MuiTypography-subtitle1 text-text nowrap">
                {data?.locationCount === 1
                  ? '1 Location'
                  : `${data?.locationCount} Locations`}
              </p>
            </div>
          ) : null}
        </div>
        {data?.locationCount > 0 && (
          <p className="text-text mb-10 MuiTypography-subtitle1">
            Updated on{' '}
            {`${dayjs(data?.updatedAt).format(
              'MMM D, YYYY h:mm A',
            )} ${getTimeWithTimeZoneAbbreviationNew(data?.updatedAt, 'z')}`}
          </p>
        )}
        <div className="chips border mb-10">
          {(() => {
            const levels = data?.threatLevels || [];

            if (!levels.length) return null;

            const first = levels[0];
            const others = levels.slice(1);
            console.log(others);
            const getChipClass = (level: string) =>
              level === 'CRITICAL'
                ? 'red'
                : level === 'HIGH'
                ? 'orange'
                : level === 'MEDIUM'
                ? 'yellow'
                : level === 'LOW'
                ? 'green'
                : '';

            const getIconClass = (level: string) =>
              level === 'CRITICAL'
                ? 'urgent-icon'
                : level === 'HIGH'
                ? 'high-icon'
                : level === 'MEDIUM'
                ? 'medium-icon'
                : level === 'LOW'
                ? 'low-icon'
                : '';

            return (
              <>
                {/* FIRST CHIP */}
                <span className={`${getChipClass(first?.level)} blue`}>
                  <i className={getIconClass(first?.level)}></i> {first?.count}{' '}
                  {formatToTitleCase(first?.level)}
                </span>

                {/* TOOLTIP FOR REMAINING */}
                {others.length > 0 && (
                  <ToolTipComponent
                    theme="light"
                    arrow
                    title={
                      <div>
                        {others.map((item: any, index: any) => (
                          <div key={index} style={{ marginBottom: 4 }}>
                            <span
                              className={`${getChipClass(item?.level)} blue`}
                            >
                              <i className={getIconClass(item?.level)}></i>{' '}
                              {item?.count}{' '}
                              {formatStringToTitleCase(item?.level)}
                            </span>
                          </div>
                        ))}
                      </div>
                    }
                  >
                    <span className="blue">+{others.length}</span>
                  </ToolTipComponent>
                )}
              </>
            );
          })()}
        </div>
        {/* THREAT TYPES WITH TOOLTIP */}
        <div className="chips border mb-10">
          {(() => {
            const types = data?.threatTypes || [];

            if (!types.length) return null;

            const first = types[0];
            const others = types.slice(1);
            const maxLength = 22; // adjust based on design

            const truncate = (text: string) => {
              if (!text) return '';
              return text.length > maxLength
                ? text.substring(0, maxLength) + '...'
                : text;
            };

            return (
              <>
                {/* First visible (truncate if needed) */}
                <span className="yellow">
                  {formatStringToTitleCase(truncate(first?.type))}
                </span>

                {/* Tooltip for remaining (full text, no truncate) */}
                {others.length > 0 && (
                  <ToolTipComponent
                    theme="light"
                    arrow
                    title={
                      <div>
                        {others.map((item: any, index: number) => (
                          <p key={index} style={{ margin: '4px 0' }}>
                            {formatStringToTitleCase(item?.type)}
                          </p>
                        ))}
                      </div>
                    }
                  >
                    <span className="blue">+{others.length}</span>
                  </ToolTipComponent>
                )}
              </>
            );
          })()}
        </div>

        {data?.actionItems?.total > 0 && (
          <p className="text-text MuiTypography-subtitle1">
            <span className="text-gray_900 MuiTypography-body2">
              {data?.actionItems?.pending}
            </span>
            /{data?.actionItems?.total} Action Items
          </p>
        )}
      </div>
    </div>
  );
};

export default ThreatCard;
